export const ROWS = 33;
export const COLS = 60;

export const TERRAIN = {
    EMPTY: 0,
    WALL: 1,
    MUD: 2,
};

export const ROLE = {
    NONE: 0,
    START: 1,
    END: 2,
};

export const NODE_STATE = {
    UNVISITED: 0,
    VISITED: 1,
    PATH: 2,
};
